
import Footer from '../../components/feature/Footer';
import Header from '../../components/feature/Header';
import PricingSection from './components/PricingSection';


function Pricing() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <PricingSection />
      </main>
      <Footer />
    </div>
  );
}

export default Pricing;
